// Modules
import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// CSS and assets
import './style.scss';

// Components
import { ReactComponent as Logo } from '@assets/images/subscription_details_header_logo.svg';
import { ReactComponent as MobileLogo } from '@assets/images/Union.svg';
import { MenuNavigation } from '@global/components/Header/components/MenuNavigation';

// Utils
import { Pages } from '@global/App/constants/constants';
import { matchCurrentLocation } from '@src/global/localization/services';
import { LOCALE_CODES } from '@global/types/types';

export const SubscritpionDetailsHeader: React.FC = () => {
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const language = i18n.language as LOCALE_CODES;

  let title = '';

  if (matchCurrentLocation(Pages.CHECKOUT)) {
    title = t('header.subtitle');
  }

  const isCheckoutPage = location.pathname === `/${language}${Pages.CHECKOUT}`;

  return (
    <header className="navigation-container">
      <div className={`header ${!title ? 'header_logged' : ''}`}>
        <div className="header__container">
          <Logo
            role="img"
            title="Logo"
            aria-label="Company Logo"
            className="header__logo header__logo--desktop"
          />

          <MobileLogo
            role="img"
            title="Logo"
            aria-label="Company Logo"
            className="header__logo header__logo--mobile"
          />

          {!isCheckoutPage && <MenuNavigation />}
        </div>
      </div>
    </header>
  );
};
